import { createContext, useContext } from 'react';

export const AdjustTransactionSettlementAndFeesStateContext = createContext();
export const AdjustTransactionSettlementAndFeesDispatchContext = createContext();

export const useAdjustTransactionSettlementAndFeesStateContext = () =>
  useContext(AdjustTransactionSettlementAndFeesStateContext);
export const useAdjustTransactionSettlementAndFeesDispatchContext = () =>
  useContext(AdjustTransactionSettlementAndFeesDispatchContext);
